<div class="row">
  <div class="col-xs-12 col-md-4">
    <app-menudesktop (contratoenvio)="recibirContrato($event)"></app-menudesktop>
  </div>
  <div class="col-xs-12 col-md-8 scyr-interior">
    <alertbox
      [messageBox]="messageCabecera"
      [typeException]="typeException"
      [messageComplet]="messageComplet"
    ></alertbox>
    <section>
      <h1>Solicitud de baja</h1>
      <p>Puede solcitar la baja de su contrato rellenando el siguiente formulario.</p>
      <div class="col-xs-12 box">
        <form
          class=""
          id="form"
          method="post"
          enctype="multipart/form-data"
          action=""
          #captchaProtectedForm="ngForm"
        >
          <h2 class="line">Datos del solicitante</h2>
          <fieldset>
            <legend class="sr-only">Formulario datos solicitante</legend>
            <div
              class="row"
              *ngIf="!contratoSeleccionado.Ficticio"
            >
              <div class="col-xs-12 col-sm-6 col-md-12">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'direccionSuministro'"
                  [setLabel]="'Dirección suministro'"
                  [setValue]="direccionSuministro"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="direccionSuministro = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'name'"
                  [setLabel]="'Nombre y apellidos'"
                  [setValue]="name"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="name = $event"
                ></sacyr-input>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-3">
                <sacyr-input
                  [setType]="'dni'"
                  [setName]="'dni'"
                  [setLabel]="'DNI'"
                  [setValue]="dni"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="dni = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'email'"
                  [setLabel]="'Email'"
                  [setValue]="email"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="email = $event"
                ></sacyr-input>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-3">
                <sacyr-input
                  [setType]="'tel'"
                  [setName]="'telefono'"
                  [setLabel]="'Teléfono'"
                  [setValue]="telefono"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="telefono = $event"
                ></sacyr-input>
              </div>
            </div>
          </fieldset>

          <h2 class="line">Datos domicilio de Suministro</h2>
          <fieldset>
            <legend class="sr-only">Formulario datos suministro</legend>
            <div
              class="row"
              *ngIf="!contratoSeleccionado.Ficticio"
            >
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'num_contrato'"
                  [setLabel]="'Número de contrato'"
                  [setValue]="num_contrato.toString()"
                  [setReadOnly]="true"
                  (outValue)="num_contrato = parseStringToInt($event)"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <label class="label-important">IMPORTANTE: La lectura aportada se tendrá en cuenta a efectos
                meramente
                informativos,
                prevaleciendo la lectura tomada por EMMASA el día del levantamiento del contador </label>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <div style="position: relative;">
                  <sacyr-input
                    [setType]="'text'"
                    [setName]="'lectura'"
                    [setLabel]="'Lectura de contador'"
                    [setValue]="lectura"
                    [setRequired]="true"
                    [setError]="lecturaInputError ? 'Introduzca una lectura valida' : ''"
                    (outValue)="lectura = $event"
                    (change)="cambiar()"
                  ></sacyr-input>
                  <a
                    (click)="_showModalAyuda=true;"
                    class="label-lectura-ayuda"
                  >
                    <span>Ayuda</span>
                    <img
                      src="assets/images/icons/ayuda.svg"
                      alt="ayuda"
                    >
                  </a>
                </div>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-6">
                <app-uploadfile
                  [projectId]="100"
                  [sectionId]="107"
                  [maxFiles]="4"
                  [maxSize]="2"
                  [fileExt]="'JPG, GIF, PNG'"
                  (uploadStatus)="refreshImages($event)"
                ></app-uploadfile>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <app-calendario
                  [date]="date"
                  (fecha)="enviar($event)"
                ></app-calendario>
                <span
                  *ngIf="dateInputError == true"
                  class="error"
                >Introduzca la fecha de lectura</span>
                <span
                  *ngIf="dateInputError == false"
                  class="error"
                ><br /></span>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6">
                <re-captcha
                  [(ngModel)]="formModel.captcha"
                  name="captcha"
                  required
                  siteKey="{{keyCapchasite}}"
                  #captchaControl="ngModel"
                >
                </re-captcha>
                <span
                  *ngIf="captchaError == true"
                  class="error"
                >Captcha debe ser resuelto</span>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="input-form input-check input-check__privacidad">
                  <input
                    type="checkbox"
                    [(ngModel)]="politicas"
                    id="agree"
                    name="agree"
                    required
                  />
                  <label for="agree">{{this.empresa}} no se responsabiliza de las imágenes subidas por el usuario.
                    ¿Acepta la
                    <a (click)="_showModalPolitica=true;">Política de Privacidad</a>?.
                  </label>
                </div>
                <span
                  *ngIf="politicasError"
                  class="error"
                ><br /><br />Acepte la política de privacidad</span>
              </div>
            </div>
          </fieldset>

        </form>
        <div class="row"> </div>
      </div>
    </section>
    <div
      class="input-form input-button"
      *ngIf="!contratoSeleccionado.Ficticio"
    >
      <button
        type="submit"
        class="btn-default"
        (click)="actualizar()"
      >Enviar</button>
    </div>
  </div>

  <!-- MODAL -->
  <sacyr-modal
    [setTemplateRef]="modal_content"
    [showModal]="showModal()"
    (closeModal)="closeModal()"
  ></sacyr-modal>

  <ng-template #modal_content>

    <ng-container *ngIf="_showModalPolitica">
      <h1>Condiciones de uso de las imágenes</h1>
      <div [innerHTML]="condicionesEnvio"></div>
    </ng-container>

    <ng-container *ngIf="_showModalAyuda">
      <div id="modal-ayuda">
        <h1>¿Cómo debe efectuar la lectura de su contador de agua?</h1>
        <strong>Según</strong> el tipo de contador de su instalación
        <strong>complete</strong> el campo Lectura
        <ul>
          <li>
            <h2 class="line">Contador Numérico</h2>
            <figure class="pop">
              <img
                src="assets/images/contador1.jpg"
                alt=""
              >
            </figure>
            <div class="modal-text">
              <p>Anotar solamente los dígitos en negro del contador.</p>
            </div>
          </li>
          <li>
            <h2 class="line">Contador de Agujas</h2>
            <figure class="pop">
              <img
                src="assets/images/contador2.jpg"
                alt=""
              >
            </figure>
            <div class="modal-text">
              <p>Anotar primero el que indica x 1000, después, el que indica x 100, a continuación x 10 y, por último,
                x 1.
                Descarte siempre las fracciones de m3 (señalados por x 0,1 y x 0,01)
                Si la aguja se encuentra entre 2 números, elija siempre el menor de ellos.</p>
            </div>
          </li>
        </ul>
      </div>
    </ng-container>

  </ng-template>
